/*
client - twilioChatClient
channel - twilioChatChannel
totalUnreadMessagesCount - Total de mensagens não lidas
subscribedChannels - lista de channels que o usuario participa
repaintChannels - repinta os channels no menu lateral.
*/

const twilioChatClient = {};
export default twilioChatClient;



// WEBPACK FOOTER //
// ./src/twilioChatClient.js